<script setup lang="ts">
import type { ClipProps } from '@/types/appTypes'

const props = withDefaults(defineProps<ClipProps>(), {
  mode: false, // false=list true=detail
  count: 0,
  mypage: false,
  dspcnt: false, // false=list true=detail
})

const storeUser = useStoreUser()

const isClip = computed(() => storeUser.isClip(props.articleTypeSlug, props.articleSlug))

const onClickClip = () => {
  if (storeUser.state.isLogin) {
    if (isClip.value) {
      storeUser.removeClip({
        article_type_slug: props.articleTypeSlug,
        article_slug: props.articleSlug,
      })
    } else {
      storeUser.addClip({
        article_type_slug: props.articleTypeSlug,
        article_slug: props.articleSlug,
      })
    }
  } else {
    if (props.mode) {
      storeUser.setLoginRedirectPath(`/${props.articleTypeSlug}/${props.articleSlug}`)
    } else {
      storeUser.setLoginRedirectPath(`/${props.articleTypeSlug}`)
    }
    navigateTo('/login')
  }
}
</script>

<template>
  <div
    class="c-container"
    v-bind:class="{ 'is-clip': isClip, 'is-mypage': mypage }"
  >
    <div v-if="!mode">
      <button
        class="c-container_list_clip"
        v-on:click="onClickClip"
      >
        <v-icon>
          mdi-attachment
        </v-icon>
      </button>
    </div>
    <div v-else>
      <button
        class="c-container_detail_clip"
        v-on:click="onClickClip"
      >
        <v-icon class="c-container_detail_clip_icon">
          mdi-attachment
        </v-icon>
        <div
          v-if="!isClip"
          class="c-container_detail_clip_label"
        >
          クリップする
        </div>
        <div
          v-else
          class="c-container_detail_clip_label"
        >
          クリップしない
        </div>
      </button>
    </div>

    <div
      v-if="(!mode && !mypage) || dspcnt"
      class="c-container_number"
    >
      {{ count }}
    </div>
  </div>
</template>

<style lang="scss" scoped>
@use "@/assets/css/foundation/mixin/responsive";

.c-container {
  display: flex;
  z-index: 2;
  align-items: flex-end;

  &_list {
    &_clip {
      width: 40px;
      height: 40px;
      border: 1px solid var(--g_color_button_border_e6e9ec);
      border-radius: 50%;
      background-color: var(--g_color_button_background_white);

      @include responsive.mq_down(sp) {
        width: 35px;
        height: 35px;
      }

      .v-icon {
        padding: 0;
        transform: scale(-1, 1) rotate(135deg);
        color: var(--color_text_base) !important;
        font-size: 29px;
      }

      &:hover {
        opacity: 0.8;
      }
    }
  }

  &_detail {
    &_clip {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 152px;
      height: 40px;

      // margin-left: 16px;
      border: 1px solid var(--color_border_control);
      border-radius: 50px;
      background-color: var(--g_color_button_background_white);
      font-size: 14px;
      letter-spacing: normal;

      &:hover {
        opacity: 0.7;
      }

      &_label {
        font-weight: bold;
      }

      @include responsive.mq_down(sp) {
        margin: 0;
      }

      &_icon {
        margin-right: 5px;
        transform: rotateZ(45deg);
        color: var(--g_color_background_black);
        font-size: 30px;
      }
    }
  }

  &.is-mypage & {
    &_list {
      &_clip {
        width: 30px;
        height: 30px;
        border: none;

        .v-icon {
          font-size: 21px;
        }
      }
    }
  }

  &.is-clip & {
    &_list {
      &_clip {
        background-color: var(--color_primary);

        .v-icon {
          color: #fff !important;
          font-size: 21px;
        }
      }
    }

    &_detail {
      &_clip {
        background-color: var(--color_primary);
        color: var(--g_color_button_text_white);
        font-size: 12px;

        &_icon {
          color: #fff !important;
          font-size: 21px;
        }
      }
    }
  }

  &_number {
    width: 39px;
    color: var(--color_primary_link);
    font-size: 14px;
    font-weight: bold;
    text-align: center;
  }
}
</style>
